import React, { FC, memo } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { IBlockWithTimetableProps } from '../types'

const BlockWithTimetable: FC<IBlockWithTimetableProps> = (props) => {
  const { title, items } = props

  return (
    <div>
      <Spacing spacing='uxlarge' />

      {title && <Heading h2={title} spacing='large' />}

      {items &&
        items.map((el, key, array) => {
          return (
            <div
              key={key}
              style={{
                paddingTop: key === 0 ? '0' : '24px',
                paddingBottom: array.length - 1 === key ? '0' : '24px',
                borderBottom: array.length - 1 === key ? '' : '1px solid #030f2317',
              }}
            >
              {el.smallText && (
                <>
                  <Text fontWeight='semibold'>{el.smallText}</Text>

                  <Spacing spacing='xxsmall' />
                </>
              )}

              {el.title && <Heading h3={el.title} spacing='small' />}

              {el.text && <Text>{el.text}</Text>}
            </div>
          )
        })}
    </div>
  )
}

export default memo(BlockWithTimetable)
